/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Center, Container, Flex, SimpleGrid, Stack, Text, VStack } from '@chakra-ui/react';
import { faList, faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import BreadcrumbComponent from '../../../components/BreadcrumbComponent/BreadcrumbComponent';
import Filter from '../../../components/MarketDevelopment/Miscellaneous/filter-dashboard';
import SaleGrossPremiumGrowthGraph from '../../../components/MarketDevelopment/MonthlySale/Dashboard/SaleGrossPremiumGrowthGraph';
import SaleInsuredPersonGenderGraph from '../../../components/MarketDevelopment/MonthlySale/Dashboard/SaleInsuredPersonGenderGraph';
import SaleMarketShareGraph from '../../../components/MarketDevelopment/MonthlySale/Dashboard/SaleMarketShareGraph';
import SalePolicyGrossPremiumGraph from '../../../components/MarketDevelopment/MonthlySale/Dashboard/SalePolicyGrossPremiumGraph';
import SaleSidebar from '../../../components/MarketDevelopment/MonthlySale/Dashboard/SaleSidebar';
import PrintLayout from '../../../components/Print/PrintLayout';
import c from '../../../constant';
import useCompanyReportStore from '../../../store/company-report-persistent-store';
import { dateRangeStringToDateRange, dateRangeToQueryString } from '../../../utils';
import composeQueries from '../../../utils/composeQueries';
import { getReportTitle } from '../Utils';

export default function MonthlySaleGraph() {
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const period = urlParams.get('period') || null;
	const reportId = urlParams.get('reportId') || null;
	const companyType = urlParams.get('companyType') || null;
	const companyId = urlParams.get('companyId') || null;
	const rangeOption = urlParams.get('rangeOption') || null;
	const rangeValue = urlParams.get('rangeValue') || null;
	const { push } = useHistory();
	const { t } = useTranslation();
	const { setCompanyType, setCompanyId } = useCompanyReportStore();

	function onApplyingFilter({ companyType = null, companyId = null, rangeOption = null, rangeValue = null }) {
		let url = '/market-development-data/monthly-sale-graph?period=' + period + '&reportId=' + reportId;

		if (companyType) {
			url = url + '&companyType=' + companyType;
		}

		if (companyId) {
			url = url + '&companyId=' + companyId;
		}

		if (rangeOption) {
			url = url + '&rangeOption=' + rangeOption;
		}

		if (rangeValue?.from && rangeValue?.to) {
			url = url + '&rangeValue=' + dateRangeToQueryString(rangeValue);
		}

		setCompanyType(companyType);

		setCompanyId(companyId);

		push(url);
	}

	return (
		<PrintLayout>
			<>
				<Container maxW="container.xl" mt="16px" mb="16px">
					<BreadcrumbComponent
						list={[
							{
								name: 'Insurance Institute Report',
								path: '/company-submission-report',
							},
							{
								name: period,
								path: '/company-submission-report?period=' + period,
							},
							{
								name: getReportTitle(reportId),
								path: composeQueries('/market-development-data?period=' + period + '&reportId=' + reportId, { companyType, companyId }),
							},
							{
								name: 'Graph',
								path: '#',
							},
						]}
					/>
					<Center className="show-only-printing">
						<Text textAlign="center" color="#62B3ED" fontFamily="Moul" fontSize={18}>
							{t('Sale Report for Insurance Company')}
						</Text>
					</Center>
					<Center mt="5">
						<Box
							w="100%"
							bg="white"
							borderRadius={c.borderRadius}
							border="1px solid #dbdbdb"
							boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
							pb="32px"
						>
							<Flex
								className="hidden-print responsive-header-for-table"
								bg="#FAFAFA"
								p="16px"
								pt="8px"
								pb="8px"
								alignItems="center"
								justifyContent="space-between"
								borderBottom="1px solid #dbdbdb"
							>
								<Text fontSize="x-large" fontWeight="bold">
									{t('Sale Report for Insurance Company')}
								</Text>
								<Flex>
									<Stack direction={['column', 'column', 'row']} justifyContent="flex-end" alignItems="center" className="hidden-print">
										<Button
											className="hidden-print"
											isLoading={false}
											isDisabled={false}
											leftIcon={<FontAwesomeIcon icon={faList} style={{ fontSize: 16 }} />}
											size="sm"
											borderRadius={c.borderRadius}
											border="1px solid #bdc3c7"
											colorScheme="gray"
											variant="solid"
											onMouseDown={() => {
												let params = '?period=' + period + '&reportId=' + reportId;
												push('/market-development-data' + composeQueries(params, { companyType, companyId }));
											}}
										>
											{t('List')}
										</Button>
										<Button
											className="hidden-print"
											isLoading={false}
											isDisabled={false}
											onClick={() => window?.print()}
											leftIcon={<FontAwesomeIcon icon={faPrint} style={{ fontSize: 16 }} />}
											size="sm"
											borderRadius={c.borderRadius}
											border="1px solid #bdc3c7"
											colorScheme="gray"
											variant="solid"
										>
											{t('Print')}
										</Button>
										<Filter
											companyType={companyType}
											companyId={companyId}
											rangeOption={rangeOption}
											rangeValue={dateRangeStringToDateRange(rangeValue)}
											onCallback={onApplyingFilter}
										/>
									</Stack>
								</Flex>
							</Flex>
							<Box p="16px" pt="0">
								<Box display={['', '', 'flex']}>
									<Box width="100%" height="auto" mt={[4, 4, 0]}>
										<VStack spacing={4}>
											<SaleSidebar companyType={companyType} companyId={companyId} range={dateRangeStringToDateRange(rangeValue)} />
											<SimpleGrid w="100%" columns={{ base: 2, sm: 1, md: 2 }} spacing={4}>
												<SaleMarketShareGraph
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<SalePolicyGrossPremiumGraph
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<SaleInsuredPersonGenderGraph
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<SaleGrossPremiumGrowthGraph
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
											</SimpleGrid>
										</VStack>
									</Box>
								</Box>
							</Box>
						</Box>
					</Center>
				</Container>
			</>
		</PrintLayout>
	);
}
